import React, { Component } from 'react';
import moment from 'moment/moment.js';
import withNotify from '../../common/withNotify';
import withGoBack from '../../common/withGoBack';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withSetsSearch from '../../common/withSetsSearch';
import withOfficeSetsFilter from '../../common/withOfficeSetsFilter';
import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import {
  getStoreLastVisitedRoute,
  onGoBack
} from '../../common/globals.js';
import {
  getShipments,
  getShipmentTracking,
  searchToObject
} from '../../utils/utils.js';
import WebIcon from '../../assets/images/web.png';

class ShipmentInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shipmentAttributes: {},
      shipmentContents: [],
      caseDates: {},
      openFlag: false,
      openFlagAttributes: {},
    };
    this.apiController = null;
  }

  _onGoBack = async () => {
    try {
      const { goBack } = this.props;
      const queryParams = searchToObject(`?${(await getStoreLastVisitedRoute()).split('?')[1]}`);
      if (queryParams.shipFromLoc && goBack.length) {
        goBack[goBack.length - 1] = `${goBack[goBack.length - 1]}?shipFromLoc=${queryParams.shipFromLoc}`;
      }
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onTrackingWebsite = () => {
    const { shipmentAttributes, openFlagAttributes, openFlag } = this.state;
    try {
      if (!shipmentAttributes.TrackingWebsite) {
        if (openFlag) {
          window.open(`http://google.com/search?q=${openFlagAttributes.TrackingNo}`);
        }
        return;
      }
      window.open(shipmentAttributes.TrackingWebsite, '_blank');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    const {
      online, notify, setLoader, params
    } = this.props;
    try {
      if (!online) {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
        return;
      }
      if (!params.hasOwnProperty('id')) {
        notify({
          type: 'error',
          message: 'No tracking number provided.',
          time: 5
        });
        return;
      }
      setLoader(true);
      const res = await getShipments({}, '');
      const shipmentsWithCrtTracking = res.data.filter((item) => item.TrackingNo === params.id);
      const currentAttributes = {
        ShipTo: shipmentsWithCrtTracking[0].ShipToLoc,
        ShipDate: shipmentsWithCrtTracking[0].ShipDate,
        DueDate: null,
        Status: 'DELIVERED',
        DeliverDate: null,
        DeliveredTo: null,
        ReceivedBy: null,
        LeftAt: null,
        Service: shipmentsWithCrtTracking[0].Service,
        TrackingNo: shipmentsWithCrtTracking[0].TrackingNo,
        ShipFromLoc: shipmentsWithCrtTracking[0].ShipFromLoc,
        Carrier: shipmentsWithCrtTracking[0].Carrier
      };
      const shipmentTracking
        = await getShipmentTracking(currentAttributes.TrackingNo, currentAttributes.Carrier);

      if (shipmentTracking.result === 'failure') {
        this.setState({
          openFlag: true,
          openFlagAttributes: currentAttributes
        });
      }

      if (shipmentTracking.result !== 'success') {
        setLoader(false);
        notify({
          type: 'error',
          message: shipmentTracking.message,
          time: 5
        });
        return;
      }
      if (shipmentTracking.result === 'success') {
        currentAttributes.DeliverDate = shipmentTracking.data.deliverDate;
        currentAttributes.Status = shipmentTracking.data.status;
        currentAttributes.ReceivedBy = shipmentTracking.data.receivedBy;
        currentAttributes.LeftAt = shipmentTracking.data.leftAt;
        currentAttributes.TrackingWebsite = shipmentTracking.data.trackingWebsite;
        currentAttributes.DueDate = shipmentTracking.data.estDate;
      }
      if (currentAttributes.ShipFromLoc === 'DEPUY') {
        this.setState({
          shipmentAttributes: currentAttributes,
          shipmentContents: shipmentsWithCrtTracking
        });
      } else {
        const caseDatesRes = {};
        const caseDateSet = new Set();
        shipmentsWithCrtTracking.forEach((item) => {
          caseDateSet.add(item.CaseDate);
        });
        caseDateSet.forEach((caseDate) => {
          caseDatesRes[caseDate] = shipmentsWithCrtTracking
            .filter((item) => item.CaseDate === caseDate);
        });
        this.setState({
          shipmentAttributes: currentAttributes,
          shipmentContents: shipmentsWithCrtTracking,
          caseDates: caseDatesRes
        });
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render = () => {
    const {
      shipmentAttributes,
      shipmentContents,
      caseDates,
      openFlagAttributes
    } = this.state;
    return (
      <section className="list-section">
        <Header
          title="Shipment Info"
          goBack={this._onGoBack}
          actionButtonExtra={{
            onClick: () => this._onTrackingWebsite(),
            title: (<img src={WebIcon} alt="web-icon" style={{ width: '25px', height: '25px', cursor: 'pointer' }} />)
          }}
        />
        <div className="container backorders-np">
          <section className="sets-section">
            <div
              className="bg-theme"
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 8,
                paddingBottom: 16,
                position: 'sticky',
                top: 45,
                zIndex: 1000,
                backgroundColor: '#212121'
              }}
            >
              <section className="shipment-details" style={{ marginBottom: '10px' }}>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Ship to: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.ShipTo}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Ship Date: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.ShipDate ? moment(shipmentAttributes.ShipDate).format('MM/DD/YY') : null}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Est Date: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.DueDate
                    ? shipmentAttributes.DueDate : ''}
                  </div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Status: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.Status}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Deliver Date: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.DeliverDate ? shipmentAttributes.DeliverDate : ''}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Received By: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.ReceivedBy ? shipmentAttributes.ReceivedBy : ''}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Left At: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.LeftAt ? shipmentAttributes.LeftAt : ''}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Service: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.Service ? shipmentAttributes.Service : openFlagAttributes.Carrier}</div>
                </div>
                <div className="row">
                  <div className="col-3 text-primary" style={{ color: '#A6A6A6' }}>Tracking #: </div>
                  <div className="col-9 text-primary">{shipmentAttributes.TrackingNo ? shipmentAttributes.TrackingNo : openFlagAttributes.TrackingNo}</div>
                </div>
              </section>
              <h4
                className="bg-card"
                style={{
                  backgroundColor: '#0E120F',
                  fontSize: 15,
                  width: '100%',
                  padding: '8px',
                  marginBottom: '10px',
                  zIndex: 999,
                }}
              >
                Shipment Contents
              </h4>
              {shipmentAttributes.ShipFromLoc === 'DEPUY' ? (
                <section>
                  <div className="row" style={{ color: '#A6A6A6' }}>
                    <div className="col-11">
                      Product
                    </div>
                    <div className="col-1" style={{ display: 'flex', justifyContent: 'center' }}>
                      Qty
                    </div>
                  </div>
                  {shipmentContents.map((shipmentItem) => (
                    <div key={shipmentItem.ID} className="row" style={{ marginBottom: '5px' }}>
                      <div className="col-11">
                        {shipmentItem.ProductNo}
                        <br />
                        {shipmentItem.ProductDescription}
                      </div>
                      <div className="col-1" style={{ display: 'flex', justifyContent: 'center' }}>
                        {shipmentItem.Qty}
                      </div>
                    </div>
                  ))}
                </section>
              ) : (
                <section>
                  {Object.keys(caseDates).length ? Object.keys(caseDates).map((caseDate) => (
                    <div key={caseDate} style={{ marginBottom: '10px' }}>
                      <div style={{ marginBottom: '5px' }}>
                        <span style={{ textDecoration: 'underline', color: '#A6A6A6' }}>
                          Case Date:
                        </span>
                        {caseDate !== 'null'
                          ? ` ${moment(caseDate).format('MM/DD/YY')}` : ' '}
                      </div>
                      {caseDates[caseDate]
                        .map((shippmentItem) => (
                          <div key={shippmentItem.ID}>
                            {shippmentItem.ItemNo ? `${shippmentItem.ItemNo}. ` : null}
                            {shippmentItem.SetName}
                            {shippmentItem.SetNo ? ` #${shippmentItem.SetNo}` : null}
                          </div>
                        ))}
                    </div>
                  )) : null}
                </section>
              )}
            </div>
          </section>
        </div>
      </section>
    );
  }
}

export default withOfficeSetsFilter(
  withSetsSearch(
    withOnline(
      withGoBack(
        withNotify(
          withLoader(
            ShipmentInfo
          )
        )
      )
    )
  )
);
